import React from "react";
import Gif from "./Gif"
import ReactDOM from 'react-dom';
import { SearchContextManager} from '@giphy/react-components'
import './ConversationStyleSheet.css';
import closeImg from '../../images/close-icon.png'


const Popup = props => {
  return ReactDOM.createPortal(
    <div className="popup-box" style={{ height: "500px",marginLeft:"20px",marginRight:"20px",maxHeight:"500px",marginBottom:"55px",marginTop:"-40px"}}>
      <div className="box">
        <div className="close-icon" onClick={props.handleClose} style={{cursor:"pointer"}}><img src={closeImg} style={{height:"8px", width:"8px", float:"left",marginBottom:"12px"}}></img></div>
        <SearchContextManager apiKey="sXpGFDGZs0Dv1mmNFvYaGUvYwKX0PWIh" theme={{}}>
         <Gif {...props}/>
        </SearchContextManager>
      </div>
    </div>
  ,document.getElementById('conver'));
};

export default Popup;





